import { Tabs, spacing4 } from '@leaftrade/leaftrade-component-library';
import React from 'react';

export const MESSAGE_TAB = {
  TEAM: 'team',
  VENDOR: 'vendor',
};

const CheckoutMessageTabs = ({ activeTab, onTabChange }) => {
  const tabOptions = [
    {
      key: MESSAGE_TAB.TEAM,
      label: 'Message to team',
      isActive: activeTab === MESSAGE_TAB.TEAM,
      renderLink: (props) => (
        <button
          {...props}
          onClick={() => onTabChange(MESSAGE_TAB.TEAM)}
          type='button'
        >
          {props.children}
        </button>
      ),
    },
    {
      key: MESSAGE_TAB.VENDOR,
      label: 'Message to vendor',
      isActive: activeTab === MESSAGE_TAB.VENDOR,
      renderLink: (props) => (
        <button
          {...props}
          onClick={() => onTabChange(MESSAGE_TAB.VENDOR)}
          type='button'
        >
          {props.children}
        </button>
      ),
    },
  ];

  return <Tabs options={tabOptions} sx={{ marginBottom: spacing4 }} />;
};

export default CheckoutMessageTabs;
